import React from 'react';
import {
    BooleanInput,
    Create,
    required,
    SelectArrayInput,
    SimpleForm,
    TextInput,
    ReferenceInput, ArrayInput, SimpleFormIterator, AutocompleteInput, NumberInput
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import Icon from '@material-ui/icons/Bookmark';

export const ConfigIcon = Icon;

const ConfigTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>Test Wizard</span>;
};


export const styles = {
    customerName: { width:'32em', fontSize: '1em', marginBottom: 5 },
    Description: { width:'64em', fontSize: '1em', marginBottom: 20, marginTop: 0 },
    maxCPU: { width:'32em', fontSize: '1em', marginTop: 0, marginBottom: 5 },
    additionalSources: { width:'64em', fontSize: '1em', marginTop: 0 },
    codec: { maxWidth:'5em', fontSize: '1em', marginTop: 0 },
    codecForm: { display: 'inline-flex', marginLeft: 10, marginTop: 0},
    audioCodec: { maxWidth:'8em', fontSize: '1em', marginTop: 0 },
    audioCodecForm: { display: 'inline-flex', marginLeft: 10, marginTop: 0},
    profile: { maxWidth: '4em', fontSize: '1em' },
    profileForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    wizardSource: { maxWidth: '14em', fontSize: '1em', marginTop: 0 },
    source: { maxWidth: '14em', fontSize: '1em' },
    sourceForm: {display: 'inline-flex'},
    rateMode: { maxWidth: '5em', fontSize: '1em' },
    rateModeForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    qualityLevel: { maxWidth: '5em', fontSize: '1em' },
    qualityLevelForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    hResolution: { maxWidth: '5em', fontSize: '1em' },
    hResolutionForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    vResolution: { maxWidth: '5em', fontSize: '1em' },
    vResolutionForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    Resolution: { maxWidth: '7em', fontSize: '1em' },
    ResolutionForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    frameRate: { maxWidth: '4em', fontSize: '1em' },
    frameRateForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    esrate: { maxWidth: '8em', fontSize: '1em', marginTop: 0 },
    esrateForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    deftsrate: { maxWidth: '12em', fontSize: '1em' },
    deftsrateForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    output: { maxWidth: '15em', fontSize: '1em' },
    outputForm: {display: 'inline-flex', marginLeft: 10, marginTop: 0},
    statmux: { maxWidth: '6em', fontSize: '1em' },
    statmuxForm: {display: 'inline-flex', marginLeft: 20, marginTop: 0},
    processingDelay: { maxWidth: '10em', fontSize: '1em'},
    processingDelayForm: { display: 'inline-flex', marginLeft: 32, marginTop: 0},
    count: { maxWidth: '5em',  fontSize: '1em' },
    countForm: { display: 'inline-flex', marginLeft: 32, marginTop: 0 },
    width: { width: '5em' },
    processingSettings: { width: 550, marginLeft: 32, fontSize: '1em', marginTop: 0 },
    delay: { width: 600, marginLeft: 32, fontSize: '1em', marginTop: 0 },
    ABRProcessings: { width:2000, marginLeft: 64, fontSize: '1em', marginTop: 0 },
};

const resolutionValidation = (value, allValues) => {
    if (value % 2) {
        return 'Resolution must be multiple of 2';
    }
    return;
};

const maxCPUValidation = (value, allValues) => {
    if (value > 87) {
        return 'Max CPU Load must be <= 87';
    }
    if (value < 5) {
        return 'Max CPU Load must be >= 5';
    }
    return;
};

const validateWizardForm = (values) => {
    const errors = {};
    //console.log(values)
    if (values.WizardConfiguration) {
        errors.WizardConfiguration = {}
        //console.log('WizardConfiguraton Exists')
        if (values.WizardConfiguration.LinearTranscodeServices) {
            errors.WizardConfiguration.LinearTranscodeServices = []
            //console.log('LinearTranscodeServices Exists')
            let index = 0
            for (const element of values.WizardConfiguration.LinearTranscodeServices) {
                errors.WizardConfiguration.LinearTranscodeServices[index] = {}
                //console.log(element);
                if (element.processing) {
                    errors.WizardConfiguration.LinearTranscodeServices[index].processing = {}
                    //console.log('processing exists')
                    if (element.processing.videoSettings) {
                        errors.WizardConfiguration.LinearTranscodeServices[index].processing.videoSettings = {}
                        if (element.processing.videoSettings.codec) {
                            if (element.processing.videoSettings.codec !== 'AudioOnly') {
                                if (!element.processing.videoSettings.esRate) {
                                    errors.WizardConfiguration.LinearTranscodeServices[index].processing.videoSettings.esRate = ['The esRate is required']
                                }
                                if (!element.processing.videoSettings.encode) {
                                    errors.WizardConfiguration.LinearTranscodeServices[index].processing.videoSettings.encode = {}
                                    errors.WizardConfiguration.LinearTranscodeServices[index].processing.videoSettings.encode.resolutionMode = ['The Resolution is required']
                                }
                            }
                        }
                    }
                }
                index = index + 1
            }
        }
    }
    //console.log(errors)
    return errors
};

const validateDescription = [required()];

const validateCodec = [required()];
const validateWizardSource = [required()];
const validateFrameRate = [required()];
//const validateAudioCodec = [required()];
const validateEsRate = [required()];

const validatehRes = [required(),resolutionValidation];
const validatevRes = [required(),resolutionValidation];

const maxCPU = [required(), maxCPUValidation]


const ConfigCreate = ({ classes, ...props }) => (
    <Create title={<ConfigTitle />}  {...props}>
        <SimpleForm redirect="list" validate={validateWizardForm}>
            <ReferenceInput
                label="Customer Name"
                source="CustomerId"
                className={classes.customerName}
                reference="customer">
                <AutocompleteInput
                    optionText="CustomerName"
                    shouldRenderSuggestions={(val) => { return val.trim().length > 0 }}
                    inputValueMatcher={
                        (input, suggestion, getOptionText) =>
                            input.toLowerCase().trim() === getOptionText(suggestion).toLowerCase().trim()
                    }
                />
            </ReferenceInput>
            <TextInput
                label="Description"
                fullWidth
                source="CustomerConfigDescription"
                validate={validateDescription}
                className={classes.Description}
            />
            <b>Pass / Fail Criteria</b>
            <NumberInput
                defaultValue={87}
                label="Max CPU load [%] - Valid range [5 - 87] - Recommended Value = 87"
                validate={maxCPU}
                source="MaxCPU"
                className={classes.maxCPU}/>
            <br/>
            <b>CPU Selection (Under construction)</b>
            <BooleanInput defaultValue={true} label="VN222-XXL: Dual AMD EPYC 7763" source="cpuList.DualAMD7763" style={{ width: 400 }} />
            <BooleanInput defaultValue={true} label="VN122-XL:  Single AMD EPYC 7763" source="cpuList.SingleAMD7763" style={{ width: 400 }} />
            <BooleanInput defaultValue={true} label="VN122-L:   Single AMD EPYC 7713P" source="cpuList.SingleAMD7713P" style={{ width: 400 }} />
            <BooleanInput defaultValue={true} label="VN111-M0:  Dual Intel Xeon 5218R" source="cpuList.DualIntel5218R" style={{ width: 400 }} />
            <BooleanInput defaultValue={true} label="VN111-S0:  Dual Intel Xeon 4210R" source="cpuList.DualIntel4210R" style={{ width: 400 }} />
            <BooleanInput defaultValue={true} label="VN111-XS:  Single Intel Xeon E-2236" source="cpuList.SingleIntelE2236" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="VN111-XL:  Dual Intel Xeon 6258R" source="cpuList.DualIntel6258R" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="VN111-L:   Dual Intel Xeon 6240R" source="cpuList.DualIntel6240R" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="VN-NODE-XL-2AC:  Dual Intel Xeon 6254" source="cpuList.DualIntel6254" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="VN-NODE-L-2AC:   Dual Intel Xeon 6240" source="cpuList.DualIntel6240" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="VN-NODE-S-2AC:   Dual Intel Xeon 4210" source="cpuList.DualIntel4210" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="EVALUATION: Dual Intel Xeon 6330" source="cpuList.DualIntel6330" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="EVALUATION: Dual Intel Xeon E5-2697 v3" source="cpuList.DualIntel2697v3" style={{ width: 400 }} />
            <BooleanInput defaultValue={false} label="EVALUATION: Single Intel Xeon E-2356G" source="cpuList.SingleIntelE2356G" style={{ width: 400 }} />
            <br/>
            <b>First Screen Wizard Configuration</b>
            <ArrayInput label="Linear Transcode Services" source="WizardConfiguration.LinearTranscodeServices" style={{ width: 1050 }}>
                <SimpleFormIterator>
                    <AutocompleteInput
                        label="Source"
                        source="inputService.source.tsfileSettings.source.fileName"
                        choices={[
                            {id: 'Mix05_8b420_480i30.ts', name: '4:2:0 8b 480i29.97@5Mbps'},
                            {id: 'Mix05_8b420_576i25.ts', name: '4:2:0 8b 576i25@5Mbps'},
                            {id: 'Mix05_8b420_720p50.ts', name: '4:2:0 8b 720p50@10Mbps'},
                            {id: 'Mix05_8b420_720p60.ts', name: '4:2:0 8b 720p59.94@10Mbps'},
                            {id: 'Mix05_8b420_1080i25.ts', name: '4:2:0 8b 1080i25@10Mbps'},
                            {id: 'Mix05_8b420_1080i30.ts', name: '4:2:0 8b 1080i29.97@10Mbps'},
                            {id: 'Mix05_8b420_1080p50.ts', name: '4:2:0 8b 1080p50@15Mbps'},
                            {id: 'Mix05_8b420_1080p60.ts', name: '4:2:0 8b 1080p59.94@15Mbps'},
                            {id: 'Mix05_8b420_2160p50.ts', name: '4:2:0 8b 2160p50@15Mbps'},
                            {id: 'Mix05_8b420_2160p60.ts', name: '4:2:0 8b 2160p59.94@15Mbps'},
                            {id: 'Mix05_10b420_480i30.ts', name: '4:2:0 10b 480i29.97@5Mbps'},
                            {id: 'Mix05_10b420_576i25.ts', name: '4:2:0 10b 576i25@5Mbps'},
                            {id: 'Mix05_10b420_720p50.ts', name: '4:2:0 10b 720p50@10Mbps'},
                            {id: 'Mix05_10b420_720p60.ts', name: '4:2:0 10b 720p59.94@10Mbps'},
                            {id: 'Mix05_10b420_1080i25.ts', name: '4:2:0 10b 1080i25@10Mbps'},
                            {id: 'Mix05_10b420_1080i30.ts', name: '4:2:0 10b 1080i29.97@10Mbps'},
                            {id: 'Mix05_10b420_1080p50.ts', name: '4:2:0 10b 1080p50@15Mbps'},
                            {id: 'Mix05_10b420_1080p60.ts', name: '4:2:0 10b 1080p59.94@15Mbps'},
                            {id: 'Mix05_10b420_2160p50.ts', name: '4:2:0 10b 2160p50@15Mbps'},
                            {id: 'Mix05_10b420_2160p60.ts', name: '4:2:0 10b 2160p59.94@15Mbps'},
                            {id: 'Mix05_10b422_480i30.ts', name: '4:2:2 10b 480i29.97@5Mbps'},
                            {id: 'Mix05_10b422_576i25.ts', name: '4:2:2 10b 576i25@5Mbps'},
                            {id: 'Mix05_10b422_720p50.ts', name: '4:2:2 10b 720p50@10Mbps'},
                            {id: 'Mix05_10b422_720p60.ts', name: '4:2:2 10b 720p59.94@10Mbps'},
                            {id: 'Mix05_10b422_1080i25.ts', name: '4:2:2 10b 1080i25@10Mbps'},
                            {id: 'Mix05_10b422_1080i30.ts', name: '4:2:2 10b 1080i29.97@10Mbps'},
                            {id: 'Mix05_10b422_1080p50.ts', name: '4:2:2 10b 1080p50@15Mbps'},
                            {id: 'Mix05_10b422_1080p60.ts', name: '4:2:2 10b 1080p59.94@15Mbps'},
                            {id: 'Mix05_10b422hdr_2160p60.ts', name: '4:2:2 10b HDR 2160p59.94@80Mbps'},
                            {id: 'AVSP_8b420_1080i25.ts', name: 'AVS+ 4:2:0 8b 1080i25@10Mbps'},
                            {id: 'AVS2_10b420_2160p50.ts', name: 'AVS2 4:2:0 10b 2160p50@15Mbps'}
                        ]}
                        validate={validateWizardSource}
                        className={classes.wizardSource}
                        formClassName={classes.sourceForm}/>
                    <AutocompleteInput
                        label="codec"
                        validate={validateCodec}
                        source="processing.videoSettings.codec"
                        choices={[
                            {id: 'H.265', name: 'H.265'},
                            {id: 'H.264', name: 'H.264'},
                            {id: 'H.264_HDT', name: 'H.264 HDT'},
                            {id: 'MPEG2', name: 'MPEG2'},
                            {id: 'AudioOnly', name: 'Audio Only'}
                        ]}
                        className={classes.codec}
                        formClassName={classes.codecForm}/>
                    <AutocompleteInput
                        label="Resolution"
                        //validate={validateFrameRate}
                        source="processing.videoSettings.encode.resolutionMode"
                        choices={[
                            {id: 'FollowInput', name: 'Follow Input'},
                            {id: 'SD', name: 'Convert to SD'},
                            {id: 'HD', name: 'Convert to HD'},
                            {id: 'FHD', name: 'Convert to FHD'},
                            {id: 'UHD', name: 'Convert to UHD'},
                        ]}
                        className={classes.Resolution}
                        formClassName={classes.ResolutionForm}/>
                    <NumberInput
                        label="esRate [kbps]"
                        //validate={validateEsRate}
                        source="processing.videoSettings.esRate"
                        className={classes.esrate}
                        formClassName={classes.esrateForm}/>
                    <AutocompleteInput
                        label="Audio Codec1"
                        //validate={validateAudioCodec}
                        source="processing.audioSettings[0][0].encode"
                        choices={[
                            {id: 'Disable', name: 'Disable'},
                            {id: 'DolbyDigital', name: 'DolbyDigital'},
                            {id: 'DolbyDigitalPlus', name: 'DolbyDigitalPlus'},
                            {id: 'DolbyAC4', name: 'DolbyAC4'},
                            {id: 'MPEG-L2', name: 'MPEG-L2'},
                            {id: 'AAC_LC', name: 'AAC_LC'},
                            {id: 'HE_AACv2', name: 'HE_AACv2'},
                            {id: 'HE_AACv1', name: 'HE_AACv1'},
                        ]}
                        className={classes.audioCodec}
                        formClassName={classes.audioCodecForm}/>
                    <AutocompleteInput
                        label="Audio Codec2"
                        //validate={validateAudioCodec}
                        source="processing.audioSettings[1][0].encode"
                        choices={[
                            {id: 'Disable', name: 'Disable'},
                            {id: 'DolbyDigital', name: 'DolbyDigital'},
                            {id: 'DolbyDigitalPlus', name: 'DolbyDigitalPlus'},
                            {id: 'DolbyAC4', name: 'DolbyAC4'},
                            {id: 'MPEG-L2', name: 'MPEG-L2'},
                            {id: 'AAC_LC', name: 'AAC_LC'},
                            {id: 'HE_AACv2', name: 'HE_AACv2'},
                            {id: 'HE_AACv1', name: 'HE_AACv1'},
                        ]}
                        className={classes.audioCodec}
                        formClassName={classes.audioCodecForm}/>
                </SimpleFormIterator>
            </ArrayInput>
            <br/>
            <b>Statmux Wizard Configuration</b>
            <ArrayInput label="Statmux services" source="WizardConfiguration.NodeStatmuxServices_all.Services" style={{ width: 1150 }}>
                <SimpleFormIterator >
                    <AutocompleteInput
                        label="Source"
                        source="inputService.source.tsfileSettings.source.fileName"
                        choices={[
                            {id: 'Mix05_8b420_480i30.ts', name: '4:2:0 8b 480i29.97@5Mbps'},
                            {id: 'Mix05_8b420_576i25.ts', name: '4:2:0 8b 576i25@5Mbps'},
                            {id: 'Mix05_8b420_720p50.ts', name: '4:2:0 8b 720p50@10Mbps'},
                            {id: 'Mix05_8b420_720p60.ts', name: '4:2:0 8b 720p59.94@10Mbps'},
                            {id: 'Mix05_8b420_1080i25.ts', name: '4:2:0 8b 1080i25@10Mbps'},
                            {id: 'Mix05_8b420_1080i30.ts', name: '4:2:0 8b 1080i29.97@10Mbps'},
                            {id: 'Mix05_8b420_1080p50.ts', name: '4:2:0 8b 1080p50@15Mbps'},
                            {id: 'Mix05_8b420_1080p60.ts', name: '4:2:0 8b 1080p59.94@15Mbps'},
                            {id: 'Mix05_8b420_2160p50.ts', name: '4:2:0 8b 2160p50@15Mbps'},
                            {id: 'Mix05_8b420_2160p60.ts', name: '4:2:0 8b 2160p59.94@15Mbps'},
                            {id: 'Mix05_10b420_480i30.ts', name: '4:2:0 10b 480i29.97@5Mbps'},
                            {id: 'Mix05_10b420_576i25.ts', name: '4:2:0 10b 576i25@5Mbps'},
                            {id: 'Mix05_10b420_720p50.ts', name: '4:2:0 10b 720p50@10Mbps'},
                            {id: 'Mix05_10b420_720p60.ts', name: '4:2:0 10b 720p59.94@10Mbps'},
                            {id: 'Mix05_10b420_1080i25.ts', name: '4:2:0 10b 1080i25@10Mbps'},
                            {id: 'Mix05_10b420_1080i30.ts', name: '4:2:0 10b 1080i29.97@10Mbps'},
                            {id: 'Mix05_10b420_1080p50.ts', name: '4:2:0 10b 1080p50@15Mbps'},
                            {id: 'Mix05_10b420_1080p60.ts', name: '4:2:0 10b 1080p59.94@15Mbps'},
                            {id: 'Mix05_10b420_2160p50.ts', name: '4:2:0 10b 2160p50@15Mbps'},
                            {id: 'Mix05_10b420_2160p60.ts', name: '4:2:0 10b 2160p59.94@15Mbps'},
                            {id: 'Mix05_10b422_480i30.ts', name: '4:2:2 10b 480i29.97@5Mbps'},
                            {id: 'Mix05_10b422_576i25.ts', name: '4:2:2 10b 576i25@5Mbps'},
                            {id: 'Mix05_10b422_720p50.ts', name: '4:2:2 10b 720p50@10Mbps'},
                            {id: 'Mix05_10b422_720p60.ts', name: '4:2:2 10b 720p59.94@10Mbps'},
                            {id: 'Mix05_10b422_1080i25.ts', name: '4:2:2 10b 1080i25@10Mbps'},
                            {id: 'Mix05_10b422_1080i30.ts', name: '4:2:2 10b 1080i29.97@10Mbps'},
                            {id: 'Mix05_10b422_1080p50.ts', name: '4:2:2 10b 1080p50@15Mbps'},
                            {id: 'Mix05_10b422_1080p60.ts', name: '4:2:2 10b 1080p59.94@15Mbps'},
                            {id: 'Mix05_10b422hdr_2160p60.ts', name: '4:2:2 10b HDR 2160p59.94@80Mbps'},
                            {id: 'AVSP_8b420_1080i25.ts', name: 'AVS+ 4:2:0 8b 1080i25@10Mbps'},
                            {id: 'AVS2_10b420_2160p50.ts', name: 'AVS2 4:2:0 10b 2160p50@15Mbps'}
                        ]}
                        validate={validateWizardSource}
                        className={classes.wizardSource}
                        formClassName={classes.sourceForm}/>
                    <AutocompleteInput
                        label="codec"
                        validate={validateCodec}
                        source="codec"
                        choices={[
                            {id: 'H.265', name: 'H.265'},
                            {id: 'H.264', name: 'H.264'},
                            {id: 'H.264_HDT', name: 'H.264 HDT'},
                            {id: 'MPEG2', name: 'MPEG2'},
                        ]}
                        className={classes.codec}
                        formClassName={classes.codecForm}/>
                    <AutocompleteInput
                        label="Resolution"
                        validate={validateFrameRate}
                        source="format"
                        choices={[
                            {id: 'FollowInput', name: 'Follow Input'},
                            {id: 'SD', name: 'Convert to SD'},
                            {id: 'HD', name: 'Convert to HD'},
                            {id: 'FHD', name: 'Convert to FHD'},
                            {id: 'UHD', name: 'Convert to UHD'},
                        ]}
                        className={classes.Resolution}
                        formClassName={classes.ResolutionForm}/>
                    <NumberInput
                        label="default TS rate [kbps]"
                        validate={validateEsRate}
                        source="serviceSettings.defaultRate"
                        className={classes.deftsrate}
                        formClassName={classes.deftsrateForm}/>
                    <AutocompleteInput
                        label="Audio Codec1"
                        //validate={validateAudioCodec}
                        source="processing.audioSettings[0][0].encode"
                        choices={[
                            {id: 'Disable', name: 'Disable'},
                            {id: 'DolbyDigital', name: 'DolbyDigital'},
                            {id: 'DolbyDigitalPlus', name: 'DolbyDigitalPlus'},
                            {id: 'DolbyAC4', name: 'DolbyAC4'},
                            {id: 'MPEG-L2', name: 'MPEG-L2'},
                            {id: 'AAC_LC', name: 'AAC_LC'},
                            {id: 'HE_AACv2', name: 'HE_AACv2'},
                            {id: 'HE_AACv1', name: 'HE_AACv1'},
                        ]}
                        className={classes.audioCodec}
                        formClassName={classes.audioCodecForm}/>
                    <AutocompleteInput
                        label="Audio Codec2"
                        //validate={validateAudioCodec}
                        source="processing.audioSettings[1][0].encode"
                        choices={[
                            {id: 'Disable', name: 'Disable'},
                            {id: 'DolbyDigital', name: 'DolbyDigital'},
                            {id: 'DolbyDigitalPlus', name: 'DolbyDigitalPlus'},
                            {id: 'DolbyAC4', name: 'DolbyAC4'},
                            {id: 'MPEG-L2', name: 'MPEG-L2'},
                            {id: 'AAC_LC', name: 'AAC_LC'},
                            {id: 'HE_AACv2', name: 'HE_AACv2'},
                            {id: 'HE_AACv1', name: 'HE_AACv1'},
                        ]}
                        className={classes.audioCodec}
                        formClassName={classes.audioCodecForm}/>

                </SimpleFormIterator>
            </ArrayInput>
            <br/>
            <b>ABR Wizard Configuration</b>
            <p style={{width: '100%'}}>vdcm.info limitation: When enabling H.264 HDT all profiles in the ladder should be set to H.264 HDT</p>
            <AutocompleteInput
                label="Input Source"
                source="WizardConfiguration.inputServices[0].source.tsfileSettings.source.fileName"
                choices={[
                    {id: 'Mix05_8b420_480i30.ts', name: '4:2:0 8b 480i29.97@5Mbps'},
                    {id: 'Mix05_8b420_576i25.ts', name: '4:2:0 8b 576i25@5Mbps'},
                    {id: 'Mix05_8b420_720p50.ts', name: '4:2:0 8b 720p50@10Mbps'},
                    {id: 'Mix05_8b420_720p60.ts', name: '4:2:0 8b 720p59.94@10Mbps'},
                    {id: 'Mix05_8b420_1080i25.ts', name: '4:2:0 8b 1080i25@10Mbps'},
                    {id: 'Mix05_8b420_1080i30.ts', name: '4:2:0 8b 1080i29.97@10Mbps'},
                    {id: 'Mix05_8b420_1080p50.ts', name: '4:2:0 8b 1080p50@15Mbps'},
                    {id: 'Mix05_8b420_1080p60.ts', name: '4:2:0 8b 1080p59.94@15Mbps'},
                    {id: 'Mix05_8b420_2160p50.ts', name: '4:2:0 8b 2160p50@15Mbps'},
                    {id: 'Mix05_8b420_2160p60.ts', name: '4:2:0 8b 2160p59.94@15Mbps'},
                    {id: 'Mix05_10b420_480i30.ts', name: '4:2:0 10b 480i29.97@5Mbps'},
                    {id: 'Mix05_10b420_576i25.ts', name: '4:2:0 10b 576i25@5Mbps'},
                    {id: 'Mix05_10b420_720p50.ts', name: '4:2:0 10b 720p50@10Mbps'},
                    {id: 'Mix05_10b420_720p60.ts', name: '4:2:0 10b 720p59.94@10Mbps'},
                    {id: 'Mix05_10b420_1080i25.ts', name: '4:2:0 10b 1080i25@10Mbps'},
                    {id: 'Mix05_10b420_1080i30.ts', name: '4:2:0 10b 1080i29.97@10Mbps'},
                    {id: 'Mix05_10b420_1080p50.ts', name: '4:2:0 10b 1080p50@15Mbps'},
                    {id: 'Mix05_10b420_1080p60.ts', name: '4:2:0 10b 1080p59.94@15Mbps'},
                    {id: 'Mix05_10b420_2160p50.ts', name: '4:2:0 10b 2160p50@15Mbps'},
                    {id: 'Mix05_10b420_2160p60.ts', name: '4:2:0 10b 2160p59.94@15Mbps'},
                    {id: 'Mix05_10b422_480i30.ts', name: '4:2:2 10b 480i29.97@5Mbps'},
                    {id: 'Mix05_10b422_576i25.ts', name: '4:2:2 10b 576i25@5Mbps'},
                    {id: 'Mix05_10b422_720p50.ts', name: '4:2:2 10b 720p50@10Mbps'},
                    {id: 'Mix05_10b422_720p60.ts', name: '4:2:2 10b 720p59.94@10Mbps'},
                    {id: 'Mix05_10b422_1080i25.ts', name: '4:2:2 10b 1080i25@10Mbps'},
                    {id: 'Mix05_10b422_1080i30.ts', name: '4:2:2 10b 1080i29.97@10Mbps'},
                    {id: 'Mix05_10b422_1080p50.ts', name: '4:2:2 10b 1080p50@15Mbps'},
                    {id: 'Mix05_10b422_1080p60.ts', name: '4:2:2 10b 1080p59.94@15Mbps'},
                    {id: 'Mix05_10b422hdr_2160p60.ts', name: '4:2:2 10b HDR 2160p59.94@80Mbps'},
                    {id: 'AVSP_8b420_1080i25.ts', name: 'AVS+ 4:2:0 8b 1080i25@10Mbps'},
                    {id: 'AVS2_10b420_2160p50.ts', name: 'AVS2 4:2:0 10b 2160p50@15Mbps'}
                ]}
                className={classes.wizardSource}
                formClassName={classes.sourceForm}/>
            <AutocompleteInput
                label="Audio Codec1"
                //validate={validateAudioCodec}
                source="WizardConfiguration.ABRServices[0].audioSettings[0][0].encode"
                choices={[
                    {id: 'Disable', name: 'Disable'},
                    {id: 'DolbyDigital', name: 'DolbyDigital'},
                    {id: 'DolbyDigitalPlus', name: 'DolbyDigitalPlus'},
                    {id: 'DolbyAC4', name: 'DolbyAC4'},
                    {id: 'MPEG-L2', name: 'MPEG-L2'},
                    {id: 'AAC_LC', name: 'AAC_LC'},
                    {id: 'HE_AACv2', name: 'HE_AACv2'},
                    {id: 'HE_AACv1', name: 'HE_AACv1'},
                ]}
                className={classes.audioCodec}
                formClassName={classes.audioCodecForm}/>
            <AutocompleteInput
                label="Audio Codec2"
                //validate={validateAudioCodec}
                source="WizardConfiguration.ABRServices[0].audioSettings[1][0].encode"
                choices={[
                    {id: 'Disable', name: 'Disable'},
                    {id: 'DolbyDigital', name: 'DolbyDigital'},
                    {id: 'DolbyDigitalPlus', name: 'DolbyDigitalPlus'},
                    {id: 'DolbyAC4', name: 'DolbyAC4'},
                    {id: 'MPEG-L2', name: 'MPEG-L2'},
                    {id: 'AAC_LC', name: 'AAC_LC'},
                    {id: 'HE_AACv2', name: 'HE_AACv2'},
                    {id: 'HE_AACv1', name: 'HE_AACv1'},
                ]}
                className={classes.audioCodec}
                formClassName={classes.audioCodecForm}/>

            <ArrayInput label="Profiles" source="WizardConfiguration.ABRServices[0].videoSettings.profiles" style={{ width: 1000 }}>
                <SimpleFormIterator >
                    <AutocompleteInput
                        label="codec"
                        validate={validateCodec}
                        source="codec"
                        choices={[
                            {id: 'H.265', name: 'H.265'},
                            {id: 'H.264', name: 'H.264'},
                            {id: 'H.264_HDT', name: 'H.264 HDT'}
                        ]}
                        className={classes.codec}
                        formClassName={classes.codecForm}/>
                    <NumberInput
                        inputProps={{step:2, min:0}}
                        label="hRes"
                        validate={validatehRes}
                        source="hResolution"
                        className={classes.hResolution}
                        formClassName={classes.hResolutionForm}/>
                    <NumberInput
                        inputProps={{step:2, min:0}}
                        label="vRes"
                        validate={validatevRes}
                        source="vResolution"
                        className={classes.vResolution}
                        formClassName={classes.vResolutionForm}/>
                    <AutocompleteInput
                        label="fps"
                        validate={validateFrameRate}
                        source="frameRate"
                        choices={[
                            {id: '12.5', name: '12.5'},
                            {id: '25', name: '25'},
                            {id: '50', name: '50'},
                            {id: '9.99', name: '9.99'},
                            {id: '14.99', name: '14.99'},
                            {id: '29.97', name: '29.97'},
                            {id: '59.94', name: '59.94'},
                            {id: 'i25', name: 'i25'},
                            {id: 'i29.97', name: 'i29.97'},
                        ]}
                        className={classes.frameRate}
                        formClassName={classes.frameRateForm}/>
                    <NumberInput
                        label="esRate [kbps]"
                        validate={validateEsRate}
                        source="esRate"
                        className={classes.esrate}
                        formClassName={classes.esrateForm}/>
                </SimpleFormIterator>
            </ArrayInput>
            <br/>
            <b>Various</b>
            <p style={{width:'100%'}}>If you need additional Local files to configure your setup select them here</p>
            <SelectArrayInput
                label="Additional sources"
                source="fileName"
                className={classes.additionalSources}
                choices={[
                    {id: 'Mix05_8b420_480i30.ts', name: '4:2:0 8b 480i29.97@5Mbps'},
                    {id: 'Mix05_8b420_576i25.ts', name: '4:2:0 8b 576i25@5Mbps'},
                    {id: 'Mix05_8b420_720p50.ts', name: '4:2:0 8b 720p50@10Mbps'},
                    {id: 'Mix05_8b420_720p60.ts', name: '4:2:0 8b 720p59.94@10Mbps'},
                    {id: 'Mix05_8b420_1080i25.ts', name: '4:2:0 8b 1080i25@10Mbps'},
                    {id: 'Mix05_8b420_1080i30.ts', name: '4:2:0 8b 1080i29.97@10Mbps'},
                    {id: 'Mix05_8b420_1080p50.ts', name: '4:2:0 8b 1080p50@15Mbps'},
                    {id: 'Mix05_8b420_1080p60.ts', name: '4:2:0 8b 1080p59.94@15Mbps'},
                    {id: 'Mix05_8b420_2160p50.ts', name: '4:2:0 8b 2160p50@15Mbps'},
                    {id: 'Mix05_8b420_2160p60.ts', name: '4:2:0 8b 2160p59.94@15Mbps'},
                    {id: 'Mix05_10b420_480i30.ts', name: '4:2:0 10b 480i29.97@5Mbps'},
                    {id: 'Mix05_10b420_576i25.ts', name: '4:2:0 10b 576i25@5Mbps'},
                    {id: 'Mix05_10b420_720p50.ts', name: '4:2:0 10b 720p50@10Mbps'},
                    {id: 'Mix05_10b420_720p60.ts', name: '4:2:0 10b 720p59.94@10Mbps'},
                    {id: 'Mix05_10b420_1080i25.ts', name: '4:2:0 10b 1080i25@10Mbps'},
                    {id: 'Mix05_10b420_1080i30.ts', name: '4:2:0 10b 1080i29.97@10Mbps'},
                    {id: 'Mix05_10b420_1080p50.ts', name: '4:2:0 10b 1080p50@15Mbps'},
                    {id: 'Mix05_10b420_1080p60.ts', name: '4:2:0 10b 1080p59.94@15Mbps'},
                    {id: 'Mix05_10b420_2160p50.ts', name: '4:2:0 10b 2160p50@15Mbps'},
                    {id: 'Mix05_10b420_2160p60.ts', name: '4:2:0 10b 2160p59.94@15Mbps'},
                    {id: 'Mix05_10b422_480i30.ts', name: '4:2:2 10b 480i29.97@5Mbps'},
                    {id: 'Mix05_10b422_576i25.ts', name: '4:2:2 10b 576i25@5Mbps'},
                    {id: 'Mix05_10b422_720p50.ts', name: '4:2:2 10b 720p50@10Mbps'},
                    {id: 'Mix05_10b422_720p60.ts', name: '4:2:2 10b 720p59.94@10Mbps'},
                    {id: 'Mix05_10b422_1080i25.ts', name: '4:2:2 10b 1080i25@10Mbps'},
                    {id: 'Mix05_10b422_1080i30.ts', name: '4:2:2 10b 1080i29.97@10Mbps'},
                    {id: 'Mix05_10b422_1080p50.ts', name: '4:2:2 10b 1080p50@15Mbps'},
                    {id: 'Mix05_10b422_1080p60.ts', name: '4:2:2 10b 1080p59.94@15Mbps'},
                    {id: 'Mix05_10b422hdr_2160p60.ts', name: '4:2:2 10b HDR 2160p59.94@80Mbps'},
                    {id: 'AVSP_8b420_1080i25.ts', name: 'AVS+ 4:2:0 8b 1080i25@10Mbps'},
                    {id: 'AVS2_10b420_2160p50.ts', name: 'AVS2 4:2:0 10b 2160p50@15Mbps'}
                ]}/>

        </SimpleForm>
    </Create>
);

export default withStyles(styles)(ConfigCreate);